import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { LANGS, LanguageService } from "./language.service";

@Injectable({ providedIn: 'root' })
export class LanguageGuard implements CanActivate {
  constructor(private languageService: LanguageService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const lang: string = route.paramMap.get('lang') || LANGS.EN;
    this.languageService.setLanguage(lang);
    return true;
  }
}
